import {
    updateItemInCollection
} from "directus/src/operations";

export async function updateOutcomes({ item, id }) {
    try {
        const query = {
            fields: [
                "id",
                "description",
                "type",
                "case_study.id",
            ],
        };
        const data = await updateItemInCollection(
            "outcomes",
            id,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}